const FormResources = {

    form_data:{
        name:           '',
        country_id:     '',
        state_id:   '',
        city_id:        '',
        timezone_id:    '',
        address:        '',
        zip_code:       '',
        email:          '',
        phone:          '',
        fax:            '',
        director:       '',
        fte_hours:      '',
        user_id:        '',
    },

    form_format:[
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Country:',
            model_name: 'country_id',
            ref:        'country_id_input',
            ref_alt:    'country_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'State:',
            model_name: 'state_id',
            ref:        'state_id_input',
            ref_alt:    'state_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'City:',
            model_name: 'city_id',
            ref:        'city_id_input',
            ref_alt:    'city_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Timezone:',
            model_name: 'timezone_id',
            ref:        'timezone_id_input',
            ref_alt:    'timezone_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  245,
            disabled:   false,
            step:       '',
            name:       'Address:',
            model_name: 'address',
            ref:        'address_input',
            ref_alt:    'address_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  15,
            disabled:   false,
            step:       '',
            name:       'Zip Code:',
            model_name: 'zip_code',
            ref:        'zip_code_input',
            ref_alt:    'zip_code_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'email',
            maxlength:  50,
            disabled:   false,
            step:       '',
            name:       'Email:',
            model_name: 'email',
            ref:        'email_input',
            ref_alt:    'email_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'tel',
            maxlength:  20,
            disabled:   false,
            step:       '',
            name:       'Phone:',
            model_name: 'phone',
            ref:        'phone_input',
            ref_alt:    'phone_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  20,
            disabled:   false,
            step:       '',
            name:       'Fax:',
            model_name: 'fax',
            ref:        'fax_input',
            ref_alt:    'fax_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  20,
            disabled:   false,
            step:       '',
            name:       'Director:',
            model_name: 'director',
            ref:        'director_input',
            ref_alt:    'director_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  20,
            disabled:   false,
            step:       '',
            name:       'Hours per week (FTES hours):',
            model_name: 'fte_hours',
            ref:        'fte_hours_input',
            ref_alt:    'fte_hours_input_alt',
            required:   false,
        },
    ]

}

export default FormResources